let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gn8aR")).then(() => parcelRequire('jSKeV'));